import Language from 'types/Language';

const initialState: Language[] = [];

export default initialState;
